import LoadingLayout from './loading.view';

export default LoadingLayout;
